// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1cVjW","detailsBorder":"styles_detailsBorder__1t4wM"};